import { useEffect, useState, useRef } from "react"
import styles from "@/components/LeadGeneration/LeadGenerationView/index.module.scss"
import useLeadGeneration from "@/i18n/useLeadGenerationi18n"
import Confirmation from "@/components/LeadGeneration/Confirmation"
import Enquiry from "@/components/LeadGeneration/Form/Enquiry"
import StickyHeader from "../StickyHeader"
import useWindowResize from "@/hooks/useWindowResize"
import { navigateToLeadGenerationAnalytics } from "../analytics"
import { hideLeadForm, selectCartState } from "@/store/features/cartSlice"
import { useDispatch, useSelector } from "react-redux"
import Modal from "@/components/core/Modal/Modal"
import RecaptchaForm from "@/components/OmniChannel/RecaptchaForm"

const LeadGenerationView = props => {
  const {
    data: authorData = {},
    stateWithCities,
    omniQRParams = {},
    isQrService = false,
    isKohlerCare=false
  } = props
  const confirmationRef = useRef(null)
  const staticText = useLeadGeneration(authorData)
  const [confirmationSuccess, setConfirmationSuccess] = useState(null)
  const [sticky, setSticky] = useState(true)
  const [showLeadForm, setShowLeadForm] = useState(false)
  const [width] = useWindowResize(true)
  const divRef = useRef()
  const [isMobile, setIsMobile] = useState(!(width >= 992))
  const { isOpenLeadForm } = useSelector(selectCartState)
  const dispatch = useDispatch()

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setSticky(entry.boundingClientRect.top > 0 && !entry.isIntersecting)
    })
    if (divRef.current) observer.observe(divRef.current)  
    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current)
      }
    }
  }, [])
  useEffect(() => {
    if (!confirmationSuccess) {
      const observer = new IntersectionObserver(([entry]) => {
        setSticky(entry.boundingClientRect.top > 0 && !entry.isIntersecting)
      })
      if (divRef.current) observer.observe(divRef.current)
    }
  }, [confirmationSuccess])
  useEffect(() => {
    setShowLeadForm(isOpenLeadForm)
  }, [isOpenLeadForm])
  useEffect(() => {
    setIsMobile(!(width > 992))
  }, [width])
  const navigateToBookAppointment = () => {
    divRef.current.scrollIntoView({
      block: isMobile ? "start" : "end",
      inline: "nearest",
      behaviour: "smooth",
    })
    navigateToLeadGenerationAnalytics()
  }
  const getHeadingTitle = () => {
    return authorData.kecFormFlag
      ? staticText.enquiryForm
      : authorData.omniChannelKECFormFlag || authorData.siteRegistrationFormFlag
      ? staticText.heading1
      : authorData.warrantyRegistrationFormFlag
      ? staticText.heading2
      : staticText.mainTitle
  }
  const getHeadingTitleForService = ()=>{
    return  authorData.warrantyRegistrationFormFlag
      ? "Enter information below to start warranty registration"
      : authorData.selfRegistrationFormFlag || authorData.amcFormFlag
        ? "Enter your information below to express your interest"
      :"Enter your information below to log a service request. "
  }
  const handleModalClose = () => {
    dispatch(hideLeadForm())
  }
  return (
    <>
      {authorData.kecFormFlag ? (
        <StickyHeader
          sticky={sticky}
          setSticky={setSticky}
          navigateToBookAppointment={navigateToBookAppointment}
          staticText={staticText}
        />
      ) : null}
      {(authorData.selfRegistrationFormFlag ||
        authorData.bathroomInspirationFormFlag) &&
      !isQrService &&
      !isKohlerCare ? (
        <Modal
          showModal={showLeadForm}
          onModalClose={handleModalClose}
          i18n={staticText}
          isConfirm={true}
        >
          <div className={styles.leadGenerationLanding}>
            <div className="lead-generation__no-margin">
              <div className="lead-generation__title">
                <div className="lead-generation__heading-capital">
                  {`Fill in the details to register and stay updated`}
                </div>
              </div>
              <span className="lead-generation__required-fields">
                {staticText.requiredFields}
              </span>
              <RecaptchaForm
                staticText={staticText}
                setConfirmationSuccess={setConfirmationSuccess}
                authorData={authorData}
                stateWithCities={stateWithCities}
                omniQRParams={omniQRParams}
                isQrService={isQrService}
              />
            </div>
          </div>
        </Modal>
      ) : null}
      {!confirmationSuccess && isQrService && (
        <div className={styles.leadGenerationLanding}>
          <div className="lead-generation" ref={divRef}>
            <div className="lead-generation__title">
              <div className="lead-generation__heading">
                {getHeadingTitleForService()}
              </div>

              <span className="lead-generation__required-fields">
                {staticText.requiredFields}
              </span>
            </div>
            <RecaptchaForm
              staticText={staticText}
              setConfirmationSuccess={setConfirmationSuccess}
              authorData={authorData}
              stateWithCities={stateWithCities}
              omniQRParams={omniQRParams}
              isQrService={isQrService}
            />
          </div>
        </div>
      )}
      {!confirmationSuccess && isKohlerCare && (
        <div className={styles.leadGenerationLanding}>
          <div className="lead-generation" ref={divRef}>
            <div className="lead-generation__title">
              <div className="lead-generation__heading">
                {getHeadingTitleForService()}
              </div>

              <span className="lead-generation__required-fields">
                {staticText.requiredFields}
              </span>
            </div>
            <RecaptchaForm
              staticText={staticText}
              setConfirmationSuccess={setConfirmationSuccess}
              authorData={authorData}
              stateWithCities={stateWithCities}
              omniQRParams={omniQRParams}
              isQrService={isQrService}
            />
          </div>
        </div>
      )}
      {!confirmationSuccess &&
        !authorData.selfRegistrationFormFlag &&
        !authorData.bathroomInspirationFormFlag &&
        !isQrService &&
        !isKohlerCare && (
          <div className={styles.leadGenerationLanding}>
            <div className="lead-generation" ref={divRef}>
              <div className="lead-generation__title">
                <div className="lead-generation__heading">
                  {getHeadingTitle()}
                </div>
                {!authorData.kecFormFlag ? (
                  <span className="lead-generation__required-fields">
                    {authorData?.omniChannelKECFormFlag ||
                    authorData?.warrantyRegistrationFormFlag ||
                    authorData?.bathroomInspirationFormFlag ||
                    authorData?.siteRegistrationFormFlag ||
                    authorData?.selfRegistrationFormFlag
                      ? staticText.requiredFields
                      : staticText.requiredInfoText}
                  </span>
                ) : (
                  ""
                )}
              </div>

              {authorData?.omniChannelKECFormFlag ||
              authorData.warrantyRegistrationFormFlag ||
              authorData.siteRegistrationFormFlag ? (
                <RecaptchaForm
                  staticText={staticText}
                  setConfirmationSuccess={setConfirmationSuccess}
                  authorData={authorData}
                  stateWithCities={stateWithCities}
                  omniQRParams={omniQRParams}
                  isQrService={isQrService}
                />
              ) : !authorData.bathroomInspirationFormFlag &&
                !authorData.selfRegistrationFormFlag &&
                !authorData?.omniChannelKECFormFlag &&
                !authorData.warrantyRegistrationFormFlag &&
                !authorData.siteRegistrationFormFlag ? (
                <Enquiry
                  staticText={staticText}
                  setConfirmationSuccess={setConfirmationSuccess}
                  authorData={authorData}
                  stateWithCities={stateWithCities}
                />
              ) : null}
            </div>
          </div>
        )}
      {confirmationSuccess && (
        <div ref={confirmationRef} className={styles.leadGenerationLanding}>
          <div className="lead-generation">
            <Confirmation
              staticText={staticText}
              setConfirmationSuccess={setConfirmationSuccess}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default LeadGenerationView
